export default __webpack_public_path__ + "assets/media/offline.c844ada8.txt";